import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { MasterVehicle } from '../entities/master-vehicle';

/**
 * Base url for api
 */
const BASE_URL = 'master-vehicles';

@Injectable({
  providedIn: 'root',
})

/**
 * Master Vehicle Service
 */
export class MasterVehicleService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }
  /**
   * Create
   *
   * @param masterVehicle MasterVehicle instance
   */
  create(masterVehicle: MasterVehicle): Observable<any> {
    return this.apiService.post(BASE_URL, masterVehicle);
  }

  /**
   * Update
   * @param vehiclem Vehiclem instance
   */
  update(masterVehicle: MasterVehicle): Observable<any> {
    const masterVehicleId = masterVehicle.plate;
    delete masterVehicle.plate;
    return this.apiService.patch(`${BASE_URL}/${masterVehicleId}`, masterVehicle);
  }

  /**
   * Delete
   *
   * @param id Primary key
   */
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${BASE_URL}/${id}`);
  }

  /**
   * Find filtered
   *
   * @param queryOptions Object with query options
   */
  findFiltered(queryOptions): Observable<MasterVehicle[]> {
    return this.apiService
      .post(`${BASE_URL}/list`, queryOptions)
      .pipe(map((masterVehicles) => masterVehicles.map((masterVehicle) => MasterVehicle.createFromJson(masterVehicle))));
  }

  /**
   * Get count for filter
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Filter object
   */
  getCount(order: string = 'plate', sort: string = 'asc', limit: number = 10, page: number = 0, filter: object = {}): Observable<object> {
    const options = { order, sort, limit, page };

    return this.apiService.post(`${BASE_URL}/count`, { ...options, ...filter });
  }
}
